import React, { useMemo } from 'react';
import { Caption, Headline, Skeleton, timeUtils } from '@sato/components';
import { observer } from 'mobx-react-lite';

import { LineChart } from '@components/Charts/LineChart';
import { useRoomTemperature } from '@hooks/useRoomTemperature';
import { localizationStore } from '@stores/localization';

import { getTemperatureLineChartCoordinates } from './ApartmentTemperature.utils';

export const ApartmentTemperature = observer(() => {
  const t = localizationStore.getTranslation;

  const { measurements, mostRecent, isLoading } = useRoomTemperature();

  const coordinates = useMemo(
    () => getTemperatureLineChartCoordinates(measurements),
    [measurements]
  );

  if (isLoading) return <Skeleton className="aspect-4/3" />;

  if (!measurements.length) return null;

  return (
    <div className="flex w-full flex-col gap-4 text-center">
      {mostRecent && (
        <div>
          <Headline level={1}>{mostRecent.value.toFixed(1)} °C</Headline>

          <Caption>
            {timeUtils.formatDate({
              date: mostRecent.timestamp,
              dateFormat: timeUtils.DATE_FORMATS.DATE_AND_TIME,
              locale: localizationStore.language,
            })}
          </Caption>
        </div>
      )}

      <LineChart values={coordinates} axisLabel="°C" />

      <Caption>{t('apartment_temperature_chart_explanation')}</Caption>
    </div>
  );
});
